import appClient from '../../common/services/AppClient';
import { endpoints } from '../../../config';
import {
    NodeBaseDto,
    WorksheetDto,
    WorksheetsSubmissionStateDto,
    WorksheetChangeDto,
    InputValueChangeRequest
} from '../types';
import { BusinessPartnerDto, BusinessRequest, BusinessDto } from '../../custom_shared/types';
import { CancelToken } from 'axios';

export default class AccountingStatementService {
    async calculateNetDue(
        sessionExtension: string,
        sessionId: string,
        balanceNodes: NodeBaseDto[],
        cancelToken?: CancelToken
    ) {
        const url = endpoints.iotaUrl + `accounting-statement/calculate-net-due/${sessionExtension}/${sessionId}`;

        return await appClient.post<Record<string, number>>(url, balanceNodes, 'json', cancelToken);
    }

    async downloadJson(sessionExtension: string, sessionId: string, worksheets: WorksheetDto[]) {
        const url = endpoints.iotaUrl + `accounting-statement/download-json/${sessionExtension}/${sessionId}`;

        return await appClient.post<Blob>(url, worksheets, 'blob');
    }

    async getWorksheetsSubmissionState(sessionExtension: string, sessionId: string) {
        const url =
            endpoints.iotaUrl + `accounting-statement/worksheets-submission-state/${sessionExtension}/${sessionId}`;

        return await appClient.get<WorksheetsSubmissionStateDto>(url);
    }

    async searchBusinessPartners(sessionExtension: string, sessionId: string) {
        const url =
            endpoints.iotaUrl + `accounting-statement/search-business-partners/${sessionExtension}/${sessionId}`;

        return await appClient.post<BusinessPartnerDto[]>(url);
    }

    async searchBusinesses(sessionExtension: string, sessionId: string, request: BusinessRequest) {
        const url = endpoints.iotaUrl + `accounting-statement/search-businesses/${sessionExtension}/${sessionId}`;

        return await appClient.post<BusinessDto[]>(url, request);
    }

    async getWorksheetsChanges(sessionExtension: string, sessionId: string) {
        const url = endpoints.iotaUrl + `accounting-statement/worksheets-changes/${sessionExtension}/${sessionId}`;

        return await appClient.get<Record<string, WorksheetChangeDto[]>>(url);
    }

    async recordWorksheetInputChange(sessionExtension: string, sessionId: string, request: InputValueChangeRequest) {
        const url =
            endpoints.iotaUrl +
            `accounting-statement/worksheets-changes/input-modified/${sessionExtension}/${sessionId}`;

        return await appClient.post<Record<string, WorksheetChangeDto[]>>(url, request);
    }

    async cleanupPendingWorksheetChanges(sessionExtension: string, sessionId: string) {
        const url =
            endpoints.iotaUrl +
            `accounting-statement/worksheets-changes/cleanup-pending/${sessionExtension}/${sessionId}`;

        return await appClient.post<void>(url);
    }
}
